import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import construction from "../../assets/images/maintenance/under-construction-2.svg";
import { Link } from "react-router-dom";

export const UnderConstruction = () => {
  return (
    <Grid
      container
      spacing={4}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ py: 2 }}
    >
      <Grid item xs={12}>
        <Box sx={{ width: { xs: 300, sm: 480 } }}>
          <img
            src={construction}
            alt="mantis"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Stack spacing={2} justifyContent="center" alignItems="center">
          {/* <Typography align="center" variant="h3">
            Under Construction
          </Typography> */}
          <Typography
            color="textSecondary"
            align="center"
            sx={{ width: "75%" }}
            variant="h6"
          >
            We are currently working on making this section better and it will
            be available soon.
          </Typography>
          <Typography
            color="textSecondary"
            align="center"
            sx={{ width: "75%" }}
          >
            In the meantime, the best way to contact us is to email us at{" "}
            <Link
              href="mailto:rotknitting@gmail.com"
              sx={{ color: "primary.main", cursor: "pointer" }}
            >
              rotknitting@gmail.com
            </Link>
          </Typography>
          <Typography
            color="textSecondary"
            align="center"
            sx={{ width: "75%" }}
          >
            Or message us on Facebook. You can also pop in any of our in-person
            sessions in the village.
          </Typography>
          <Button
            component={Link}
            onClick={() =>
              window.open("https://www.facebook.com/rot.knitting/", "_blank")
            }
            variant="contained"
          >
            View Facebook profile
          </Button>
          <Button component={Link} to={"/"} variant="secondary">
            Back To Home
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};
